<template>
  <div class="napaItem" v-if="item.requester">
    <figure class="napaItemImage">
      <img
        :src="getAvatarLink(item.requester.avatar, '/images/camera-icon.png')"
        alt=""
        style="object-fit: contain;"
      />
    </figure>
    <div :class="'napaItemText napaItemText--' + item.requester.roleName">
      <div>
        <h6 class="napaItemTitle">
          {{
            item.requester.roleName == $role.CORP ? "보낸 기업" : "보낸 사람"
          }}
        </h6>
        <h3 class="napaItemDesc">{{ item.requester.name }}</h3>
        <h6 class="napaItemTime">{{ time }}</h6>
      </div>
      <MainBadge
        :title="`NAP ${getBtnLabelNapAdmin(item.status)}`"
        :variant="getBadgeVariant(item.status)"
      />
    </div>

    <MainButton
      size="large"
      variant="contained"
      :btnText="getNapStatus(item.status).btnText"
      :color="getNapStatus(item.status).btnColor"
      @click="$emit('openModal', item)"
    />
  </div>
</template>
<script>
import MainButton from "@/components/button/MainButton.vue";
import MainBadge from "@/components/badge/MainBadge.vue";
import matchingColorMixins from "@/mixins/matching-color-mixins";
import moment from "moment";

export default {
  name: "ItemAdminNapMatching",
  components: { MainButton, MainBadge },
  mixins: [matchingColorMixins],
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      objStatus: {},
    };
  },
  computed: {
    time() {
      if (!this.item?.submittedTime) return "";
      return moment(this.item?.submittedTime).format("YYYY.MM.DD A hh:mm");
    },
  },
};
</script>
